import React from "react";

import { ContentArchive } from "~components/shared/latest/content-archive/ContentArchive";
import { VariantBaseWithHeader } from "~components/shared/variant-base/VariantBase";
import type { PaginationProps } from "~types/lineup";
import { type VariationComponent, ZoneColumnCombo } from "~types/types";
import { integrityError } from "~utils/moduleIntegrity";

import integrityCheck from "./LineupContentArchive.integrity";
import { PREVIEW_NOTES } from "./previewNotes";
import styles from "./LineupContentArchive.module.css";

export type LineupContentArchiveProps = VariationComponent & PaginationProps;

const SUPPORTED_REGIONS: ZoneColumnCombo[] = [
    ZoneColumnCombo.leftContentWell,
    ZoneColumnCombo.fullWidthContentWell,
];

export default function LineupContentArchive(props: LineupContentArchiveProps) {
    const {
        items,
        onRequestPaginate,
        paginationLoading,
        renderingLocation,
        paginationAvailable,
    } = props;

    const integrity = integrityCheck(props);

    if (integrity.length) return integrityError(integrity);

    return (
        <VariantBaseWithHeader
            source={props}
            className={styles.LineupContentArchive}
            supportedRegions={SUPPORTED_REGIONS}
            previewNotes={PREVIEW_NOTES}
        >
            <ContentArchive
                onRequestPaginate={onRequestPaginate}
                paginationLoading={paginationLoading}
                paginationAvailable={paginationAvailable}
                renderingLocation={renderingLocation}
                items={items}
            />
        </VariantBaseWithHeader>
    );
}
